import React, { FC } from 'react';
import ProductCard from 'common/ProductCard';
import { ProductsCardsProps } from './models';

import './ProductsCards.scss';

const ProductsCards: FC<ProductsCardsProps> = ({
  productsCards,
  learnMoreLabel,
  currentCategory,
}) => (
  <div className="products-list__cards" data-testid="products-list-cards">
    {productsCards.map(
      ({
        productTitle,
        productTitleWithSize,
        productTitleShort,
        productTitleLong,
        productSize,
        url,
        productImage,
        localProductImage,
        productEAN,
        variantProductCards,
      }) => (
        <ProductCard
          key={`${productTitle}-${productImage}`}
          {...{
            productEAN,
            productTitle,
            productTitleWithSize,
            productTitleShort,
            productTitleLong,
            productSize,
            url,
            productImage,
            localProductImage,
            learnMoreLabel,
            variantProductCards,
            currentCategory,
          }}
        />
      )
    )}
  </div>
);

export default ProductsCards;
